import CheckedForColumnsVue from "@/components/functionals/checkedForColumns.vue";

export async function GetCustomerDocument(thiss) {
  let Parameters = {
    params: {
      UserID: thiss.currentUser.UserID,
      CompanyId: thiss.currentUser.CompanySelected
    }
  };

  let tableData = [];

  if (
    thiss.currentUser.PositionID == 52 ||
    thiss.currentUser.PositionID == 74 ||
    thiss.currentUser.PositionID == 90 ||
    thiss.currentUser.PositionID == 99 ||
    thiss.currentUser.PositionID == 37 ||
    thiss.currentUser.PositionID == 53 ||
    thiss.currentUser.PositionID == 56 ||
    thiss.currentUser.PositionID == 93 ||
    thiss.currentUser.PositionID == 101
  ) {
    await thiss.$http
      .get("/api/customers/GetCustomersAndDocuments", Parameters)
      .then((response) => {
        let data = response.data;
        tableData = data;
      });
  }
  return tableData;
}

export const CustomerDocumentColumns = [
  {
    prop: "ClientCode",
    label: "Codigo",
    width: 170,
    align: "left"
  },
  {
    prop: "Name",
    label: "Nombre",
    width: 400,
    align: "left"
  },
  {
    prop: "Contratos",
    label: "Contratos",
    align: "center",
    formatter: CheckedForColumnsVue
  },
  {
    prop: "RegistroMercantil",
    label: "Registro Mercantil",
    align: "center",
    formatter: CheckedForColumnsVue
  },
  {
    prop: "Cedula",
    label: "Cedula",
    align: "center",
    formatter: CheckedForColumnsVue
  },
  {
    prop: "Otros",
    label: "Otros documentos",
    align: "center",
    formatter: CheckedForColumnsVue
  }
];
